<template>
	<b-container>
		<b-row>
			<b-col>
				<h1 class="vrnu-headline">Übersicht</h1>
        <vrnu-text-box v-bind:variant="'info'">
          Willkommen <b>{{ $auth.user().firstname }} {{ $auth.user().lastname }}</b>, beim Administrations-System der VR-Youngstarclub App.
          Sollten Sie Hilfe bei der Verwendung des Systems benötigen, wenden Sie sich an eine Kontaktperson im <router-link to="/help" class="vrnu-link">Hilfebereich</router-link>.
          Sie können auf die nachfolgend aufgelisteten Bereiche zugreifen.
        </vrnu-text-box>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<muuri-grid class="muuri-wrapper">
					<component 	v-for="(box, index) in countBoxes"
								v-if="$auth.check(box.roles)"
								v-bind:is="'item-' + box.size"
								v-bind:key="index">
						<h6 class="vrnu-headline-small">{{ box.text }}</h6>
						<div 	v-if="typeof box.icon !== 'undefined'"
								class="icon-wrapper">
							<span v-bind:class="box.icon"></span>
						</div>
						<div	v-else>
							<div v-if="box.size == 'md'">
								<div class="count-wrapper-small d-block d-sm-none">
									{{ counts[box.name] }}
								</div>
								<div class="count-wrapper-big d-none d-sm-block">
									{{ counts[box.name] }}
								</div>
							</div>
							<div v-else>
								<div class="count-wrapper-small">
									{{ counts[box.name] }}
								</div>								
							</div>
						</div>
						<div 	v-on:click="redirect(box.name)"
								v-bind:class="(box.size == 'sm') ? ('click-wrapper-small') : ('click-wrapper-large')"></div>
					</component>
				</muuri-grid>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
// Organize imports
import { ItemLink, ItemSm, ItemMd, ItemLg } from 'vue-muuri'

export default {
	data: function() {
	    return {
	    	counts: {
	    		providers: 0,
	    		coupons: 0,
	    		media: 0,
	    		customers: 0,
	    		users: 0,
	    	},
	    	countBoxes: [
	    		 { name: "providers", text: "Anbieter", size: "md", roles: ['user', 'superadmin']},
	    		 { name: "media", text: "Medien", size: "sm", roles: ['user', 'superadmin']},
	    		 { name: "users", text: "Systembenutzer", size: "sm", roles: ['admin', 'superadmin']},
	    		 { name: "coupons", text: "Gutscheine", size: "md", roles: ['user', 'superadmin']},
	    		 { name: "profile", text: "Profil verwalten", size: "sm", icon: "icon-user"},
	    		 { name: "help", text: "Hilfe", size: "sm", icon: "icon-help-circled"},
	    		 { name: "logout", text: "Logout", size: "sm", icon: "icon-lock"},
	    		 { name: "customers", text: "Kunden", size: "md", roles: ['user', 'support', 'superadmin']},
	    	],
	    };
	},
	methods: {
		redirect: function(target) {
			if(target == 'logout') {
				this.$auth.logout({
					redirect: '/login',
				});
			} else {
				this.$router.push({ path: target });
			}
		},
	},
	created: function() {

	  // Retrieve user role to decide, which counts to load
	  var role = this.$auth.user().role;

	  if(role !== 'support' && role !== 'admin') {
      this.$http.get('count/providers').then(function(result) {
        this.counts.providers = result.body;
      }, response => {
        this.counts.providers = 0;
      });
    }

    if(role !== 'support' && role !== 'admin') {
      this.$http.get('count/media').then(function (result) {
        this.counts.media = result.body;
      }, response => {
        this.counts.media = 0;
      });
    }

    if(role !== 'support' && role !== 'admin') {
      this.$http.get('count/coupons').then(function (result) {
        this.counts.coupons = result.body;
      }, response => {
        this.counts.coupons = 0;
      });
    }

    if(role !== 'user' && role !== 'support') {
      this.$http.get('count/users').then(function (result) {
        this.counts.users = result.body;
      }, response => {
        this.counts.users = 0;
      });
    }
		
    if(role !== 'admin') {
      this.$http.get('count/customers').then(function (result) {
        this.counts.customers = result.body;
      }, response => {
        this.counts.customers = 0;
      });
    }
	},
	components: {
		ItemLink,
		ItemSm,
		ItemMd,
		ItemLg
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.muuri-wrapper {
	position: relative;
}
.item {
	padding: 20px;
	background: #FF6600 !important;
	color: #fff;
	cursor: pointer;
}
.count-wrapper-small {
	position: relative;
	top: -30px;
	height: 70px;
	
	text-align: center;
	
	font-size: 7rem;
}
.count-wrapper-big {
	position: relative;
	top: -5px;
	height: 70px;
	
	text-align: center;
	
	font-size: 11rem;
}
.icon-wrapper {
	position: relative;
	top: -20px;
	height: 70px;
	
	text-align: center;
	
	font-size: 6.5rem;
}
.overview-box {
	max-width: 200px;
	max-height: 200px;
	margin: 0px 20px 20px 0px;
	
	float: left;
	
	background-color: #ff6600;
}
.box-wrapper {
	position: relative;
	z-index: 100;
	
	/*
	top: -20px;
	right: -20px;
	bottom: -20px;
	left: -20px;
	*/
}
.click-wrapper-small {
	position: absolute;
	width: 200px;
	height: 200px;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: -20px;
}
.click-wrapper-large {
	position: absolute;
	width: 410px;
	height: 410px;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	margin: -20px;
}
.text-link {
  color: #ff6600;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/02_overview/Overview.vue